import { Button } from 'antd';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import useRingList from '../../../../queries/useRingList';
import BindCallToRequestModal from './components/BindCallToRequestModal/BindCallToRequestModal';
import { generateFilters } from './utils/utils';
import { columnKeys } from './constants/constants';
import useBindCallsByRequest from '../../../../mutations/useBindCallsByRequest';
import { useIsDispatcher } from '../../../../hooks/useIsDispatcher';

const INITIAL_DATE = [moment().subtract(7, 'days'), moment()];

const BindCallToRequestFromList = ({ requestId, onSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState(null);
  const [date, setDate] = useState(INITIAL_DATE);

  const isDispatcher = useIsDispatcher();

  const { data: ringList, isFetching: isRingListFetching } = useRingList(
    {
      fromDate: date[0].toISOString(),
      toDate: date[1].toISOString(),
    },
    {
      select: (data) => {
        if (data?.length > 0) {
          return data?.map((item) => ({
            ...item,
            key: item.uniqueId,
          }));
        }

        return data;
      },
    }
  );

  const { isLoading, onBindCallsByRequest } = useBindCallsByRequest();

  const disabled = isRingListFetching || !value || isLoading;

  const companiesFilters = useMemo(
    () =>
      generateFilters(
        ringList,
        columnKeys.serviceCompany,
        columnKeys.serviceCompany
      ),
    [ringList]
  );

  const operatorsFilters = useMemo(
    () => generateFilters(ringList, 'operator.id', columnKeys.operator),
    [ringList]
  );

  const handleClose = () => {
    setVisible(false);
    setValue(null);
    setDate(INITIAL_DATE);
  };

  const handleClick = () => {
    setVisible((prev) => !prev);
  };

  const handleRowClick = (value) => {
    setValue(value);
  };

  const handleSuccess = async () => {
    await onBindCallsByRequest({
      callId: value?.callerId,
      requestId,
      callUniqueId: value?.uniqueId,
    });

    handleClose();

    onSuccess();
  };

  const handleChangePicker = (date) => {
    setDate(date);
  };

  useEffect(() => {
    setValue(null);
  }, [ringList]);

  if (!isDispatcher) return null;

  return (
    <>
      <Button
        ghost
        block
        type="primary"
        style={{ marginBottom: '12px' }}
        onClick={handleClick}
      >
        Прикрепить звонок
      </Button>
      <BindCallToRequestModal
        visible={visible}
        value={value}
        isFetching={isRingListFetching}
        data={ringList}
        onClose={handleClose}
        onRowClick={handleRowClick}
        onSuccess={handleSuccess}
        title={`Прикрепить звонок к заявке № ${requestId}`}
        operatorsFilters={operatorsFilters}
        companiesFilters={companiesFilters}
        disabled={disabled}
        onChangePicker={handleChangePicker}
        date={date}
      />
    </>
  );
};

export default BindCallToRequestFromList;
